import React, { Component } from 'react';
import { Form, Modal, Input, Select } from 'antd';
import './index.less';

const { Item } = Form;
const { TextArea } = Input;

class AddMoal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      attributeTypes: [
        {
          val: 'text',
          name: '输入型',
        },
        {
          val: 'select',
          name: '选项型',
        },
        {
          val: 'contact',
          name: '手机号码',
        },
      ],
    };

    this.handleCancel = this.handleCancel.bind(this);
    this.handleOk = this.handleOk.bind(this);
  }

  handleCancel() {
    const { handleCancel } = this.props;

    if (handleCancel) {
      handleCancel();
    }
  }

  handleOk() {
    const { form, handleOk, roleSign } = this.props;
    const { validateFields } = form;

    validateFields((err, { attributeName, attributeType, selectValue }) => {
      if (!err && handleOk) {
        handleOk({
          attributeName,
          attributeType,
          selectValue,
          roleSign,
        });
      }
    });
  }

  render() {
    const { attributeTypes } = this.state;
    const { form } = this.props;

    const { getFieldDecorator, getFieldsValue } = form;

    const formItemLayout = {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 16,
      },
    };

    const { attributeType } = getFieldsValue(['attributeType']);

    return (
      <Modal
        title="添加自定义信息"
        visible
        centered
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        className="modal-form-personnel-add "
      >
        <Item {...formItemLayout} label="信息名称">
          {getFieldDecorator('attributeName', {
            rules: [{ required: true, message: '请输入信息名称' }],
          })(<Input />)}
        </Item>

        <Item {...formItemLayout} label="信息类型">
          {getFieldDecorator('attributeType', {
            rules: [{ required: true, message: '请选择信息类型' }],
          })(
            <Select placeholder="请选择">
              {attributeTypes.map(item => (
                <Select.Option value={item.val} key={item.val}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          )}
        </Item>

        {attributeType === 'select' && (
          <Item wrapperCol={{ offset: 6, span: 16 }}>
            {getFieldDecorator('selectValue', {
              rules: [
                {
                  validator: (rule, value, callback) => {
                    if (attributeType === 'select' && !value) {
                      return callback(new Error('请输入选项内容'));
                    }
                    return callback();
                  },
                },
              ],
            })(<TextArea placeholder="请输入选项内容，选项中间用英文逗号“ , ”隔开" rows="4" />)}
          </Item>
        )}
      </Modal>
    );
  }
}

export default Form.create()(AddMoal);
